import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const NewYorkMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='new-york'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='NY_ZS'
				points='834.24 533.48 819.98 610.41 815.05 721.68 818.51 749.05 801.89 764.98 804.28 782.85 787.82 802.9 790.71 808.61 809.4 802.31 845.34 796.56 876.23 785.67 905.48 782.6 928.29 776.14 960.78 762.52 985.72 780 949.02 803.99 924.41 814.16 880.39 824.34 809.39 846.25 781.27 853.64 769.78 845.1 770.95 824.91 767.65 821.15 775.96 791.22 674.14 731.06 645.1 708.7 631.86 679.28 600.71 632.91 584.27 628.44 391.45 631.97 132.39 629.79 64.47 627.45 75.6 574.33 106.98 556.01 141.36 528.48 834.24 533.48'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NY_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NY_ZS')}
			/>
			<polygon
				id='NY_ZN'
				points='834.24 533.48 843.51 483.53 841.46 386.04 835.98 363.44 821.75 353.3 818.9 279.14 827.45 223.72 818.66 177.94 821.05 151.88 818.51 130.37 642.89 139.06 602.53 156.15 563.94 194.04 542.69 222.28 530.15 243.15 485.52 275.69 483.43 290.58 489.43 320.44 495.52 340.11 488.44 364.17 460.75 389.02 428.17 412.84 393.57 421.94 373.18 421.75 276.28 401.45 222.72 403.51 184.82 408.85 163.72 421.79 161 439.62 171.83 456.19 179.73 472.15 173.58 501.51 141.36 528.48 834.24 533.48'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'NY_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('NY_ZN')}
			/>
			<rect
				x='660.33'
				y='580.51'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M659.72,620.04l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M694.2,616.86c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='623.75'
				y='301.13'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M623.14,340.66l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M657,343.73l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='781.35 803.54 781.46 807.86 786 807.86 781.52 810.53 781.63 814.85 778.76 812.18 774.28 814.85 776.98 810.53 774.1 807.86 778.65 807.86 781.35 803.54'
				className='shape'
			/>
			<rect x='780.84' y='816.56' width='109' height='20' fill='none' className='shape' />
			<path
				d='M781.58,833.6l3.08-16.18h2.18l3.71,9.16c.72,1.84,1.08,3.12,1.42,4.51l.05-.03c.09-1.45.26-2.8.68-5.06l1.63-8.58h1.88l-3.08,16.18h-1.97l-3.69-9.14c-.79-2-1.15-3.13-1.5-4.67l-.07.02c-.18,1.51-.44,3.13-.85,5.33l-1.6,8.46h-1.88Z'
				className='shape'
			/>
			<path
				d='M807.48,832.93c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM805.28,823.28c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M815.22,821.99l.41,6.53c.09,1.44.08,2.18.06,3.12h.05c.28-.76.7-1.75,1.27-2.91l3.45-6.74h1.73l.73,6.61c.12,1.28.2,2.27.18,3.04h.06c.31-.94.63-1.83,1.1-2.95l3.13-6.7h2.03l-5.74,11.61h-1.85l-.77-6.31c-.11-1.08-.18-2.07-.17-3.09h-.05c-.49,1.12-.82,2-1.35,3.03l-3.33,6.37h-1.86l-1.07-11.61h1.96Z'
				className='shape'
			/>
			<path
				d='M841.83,833.6l1.28-6.72-3.12-9.46h2.12l1.57,5.24c.41,1.42.57,2.08.69,2.7h.05c.39-.67.95-1.58,1.73-2.78l3.49-5.16h2.33l-6.88,9.44-1.27,6.74h-1.99Z'
				className='shape'
			/>
			<path
				d='M862.97,826.55c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM854.05,829.02c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M866.79,833.6l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M876.82,833.6l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.76,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<polygon
				points='781.86 485.05 781.96 489.37 786.51 489.37 782.03 492.04 782.14 496.36 779.26 493.69 774.78 496.36 777.48 492.04 774.61 489.37 779.15 489.37 781.86 485.05'
				className='shape'
			/>
			<rect x='699.09' y='462.25' width='80.39' height='20' fill='none' className='shape' />
			<path
				d='M703.12,474.17l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM708.55,472.59l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path d='M715.85,479.29l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M728.88,462.25l-1.53,7.54h.05c1.03-1.55,2.52-2.37,4.08-2.37,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-3,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM726.37,474.8c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M746.49,479.29c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM747.78,469.17c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M753.79,479.29l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M771.42,467.68l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='438.95 446.64 439.06 450.96 443.61 450.96 439.13 453.63 439.23 457.96 436.36 455.28 431.88 457.96 434.58 453.63 431.7 450.96 436.25 450.96 438.95 446.64'
				className='shape'
			/>
			<rect x='443.6' y='428.41' width='104.05' height='20' fill='none' className='shape' />
			<path
				d='M444.6,442.95c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.03-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M460.19,433.84l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<path
				d='M470.66,445.45l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M488.05,445.45c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM489.34,435.33c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M503.29,444.99c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M519.21,433.84l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M523.03,443.43c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M542.68,444.79c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM540.48,435.13c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='200.82 471.14 200.93 475.46 205.47 475.46 200.99 478.13 201.1 482.46 198.22 479.79 193.74 482.46 196.45 478.13 193.57 475.46 198.12 475.46 200.82 471.14'
				className='shape'
			/>
			<rect x='205.47' y='482.12' width='85.04' height='20' fill='none' className='shape' />
			<path
				d='M209.24,483.21c.99-.2,2.15-.34,3.47-.34,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.09-3.35-.23l2.99-15.83ZM208.48,497.55c.51.08,1.09.11,1.64.11,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM209.96,489.85h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M232.38,487.55l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.19.22-1.96l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M251.2,483.76c-.31-.15-.71-.23-1.17-.23-1.58,0-2.35,1.54-2.69,3.46l-.1.56h2.59l-.31,1.56h-2.58l-1.9,10.04h-1.99l1.91-10.04h-4.7l-1.9,10.04h-1.98l1.9-10.04h-1.55l.3-1.56h1.55l.1-.53c.27-1.38.78-2.83,1.74-3.8.68-.67,1.59-1.11,2.81-1.11.61,0,1.12.15,1.5.35l-.61,1.54c-.25-.13-.6-.23-.96-.23-1.58,0-2.21,1.62-2.53,3.3l-.09.48h4.71l.11-.62c.29-1.61.86-3.11,1.9-4.05.74-.66,1.75-1.03,2.75-1.03.8,0,1.32.15,1.59.31l-.43,1.59Z'
				className='shape'
			/>
			<path
				d='M259.52,499.16c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM260.81,489.04c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M266.78,499.16l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M285.83,492.11c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM276.91,494.58c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='395.39 555.86 395.49 560.18 400.04 560.18 395.56 562.85 395.67 567.18 392.79 564.51 388.31 567.18 391.01 562.85 388.14 560.18 392.68 560.18 395.39 555.86'
				className='shape'
			/>
			<rect x='316.31' y='537.63' width='77.2' height='20' fill='none' className='shape' />
			<path d='M322.1,538.49l-3.08,16.18h-1.99l3.08-16.18h1.99Z' className='shape' />
			<path
				d='M330.34,539.94l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M335.08,554.67l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M358.02,554.67c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM359.31,544.55c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M373.26,554.21c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M385.19,554.67c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM386.48,544.55c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
		</svg>
	);
};

NewYorkMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default NewYorkMap;
